export default __webpack_public_path__ + "static/media/212.5ea7939f.gif";